module.exports = __webpack_public_path__ + "img/slideshow1.bf3efeb1.jpeg";